<template>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <a href="https://goo.gl/maps/NVJFWt2mepF2" target="_blank" class="content">
              <font-awesome-icon icon="map-marker" class="fas"></font-awesome-icon>
              <span target="_blank">Bistrita – Str. Calea Moldovei nr 17</span>
            </a>
          </div>
          <div class="col-lg-3 col-md-6">
            <a class="content" href="tel:0754094617">
              <font-awesome-icon icon="phone" class="fas"></font-awesome-icon>
              <span>0754 094 617</span>
            </a>
          </div>
          <div class="col-lg-3 col-md-6">
            <a href="mailto:radudiafanis@gmail.com" class="content">
              <font-awesome-icon icon="envelope" class="fas"></font-awesome-icon>
              <span>radudiafanis@gmail.com</span>
            </a>
          </div>
          <div class="col-lg-2 col-md-6">
            <div class="content last">
              <button @click="show()">Contact</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  data() {
    return {
      name: "Footer"
    };
  },
  methods: {
    show() {
      this.$modal.show("contact-modal");
    },
    hide() {
      this.$modal.hide("contact-modal");
    }
  }
};
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/layouts/Footer.vue